import { cn } from '@/lib/utils';

interface Props {
  /** Data freshness in minutes. Pulses green if < 60. */
  ageMinutes: number;
  className?: string;
}

export function LivePulse({ ageMinutes, className }: Props) {
  const fresh = ageMinutes < 60;
  return (
    <span
      title={`Updated ${ageMinutes}m ago`}
      className={cn('relative inline-flex h-2 w-2 items-center justify-center', className)}
      aria-label={`Data updated ${ageMinutes} minutes ago`}
    >
      <span
        className={cn(
          'absolute inline-flex h-full w-full rounded-full opacity-75',
          fresh ? 'animate-pulse-dot bg-positive' : 'bg-muted-foreground/40',
        )}
      />
      <span
        className={cn(
          'relative inline-flex h-1.5 w-1.5 rounded-full',
          fresh ? 'bg-positive' : 'bg-muted-foreground/60',
        )}
      />
    </span>
  );
}
